module.exports = __webpack_public_path__ + "img/咨询@3x.8a351a47.png";